export const procurementFr = {
  orderStatus: {
    DRAFT: 'Brouillon',
    SENT: 'Envoyé',
    CONFIRMED: 'Confirmé',
    PARTIALLY_RECEIVED: 'Partiellement reçu',
    RECEIVED: 'Entièrement reçu',
    BILLED: 'Facturé',
    CANCELLED: 'Annulé',
  },
  receiptStatus: {
    DRAFT: 'Brouillon',
    POSTED: 'Comptabilisé',
    CANCELLED: 'Annulé',
  },
  qualityStatus: {
    ACCEPTED: 'Accepté',
    DAMAGED_REJECTED: 'Endommagé / rejeté',
    UNDER_QUARANTINE: 'En quarantaine',
  },
  invoiceStatus: {
    DRAFT: "En attente d'examen",
    MATCHED: 'Correspondance',
    DISCREPANCY: 'Écart de prix',
    APPROVED_FOR_PAYMENT: 'Paiement approuvé',
    PAID: 'Payé',
    CANCELLED: 'Annulé',
  },
  matchStatus: {
    PERFECT_MATCH: 'Correspondance parfaite',
    TOLERANCE_ACCEPTED: 'Dans les limites de tolérance',
    PRICE_MISMATCH: 'Inadéquation des prix',
    QTY_MISMATCH: 'Incompatibilité de quantité',
    MANUALLY_OVERRIDDEN: 'Accepté manuellement',
  },
  orders: {
    invalidNumber: 'Saisissez un nombre valide ; la quantité doit être supérieure à 0.',
    invalidTax: 'Saisissez un taux entre 0 et 100.',
    title: 'Commandes fournisseur',
    subtitle: 'Créer, envoyer et suivre les commandes fournisseurs.',
    cardTitle: 'Aperçu de la commande',
    cardDescription: 'Tous les bons de commande avec état de livraison et valeur de la commande.',
    create: 'Nouveau bon de commande',
    newReceipt: 'Enregistrer la réception des marchandises',
    searchPlaceholder: 'Rechercher un numéro de commande ou un fournisseur',
    error: "Les bons de commande n'ont pas pu être chargés.",
    emptyTitle: 'Aucun bon de commande trouvé',
    emptyHint: "Créez un bon de commande pour démarrer le processus d'approvisionnement.",
    columns: {
      number: 'Numéro de commande',
      supplier: 'Fournisseur',
      orderDate: 'Date de commande',
      delivery: 'Date de livraison',
      status: 'Statut',
      total: 'Valeur de la commande',
      article: 'Article',
      quantity: 'Quantité',
      unit: 'Unité',
      price: "Prix d'achat",
      tax: '% TVA',
      lineNet: 'Net',
      freeText: 'Texte libre',
    },
    created: 'Le bon de commande {{number}} a été créé.',
    saved: 'Bon de commande enregistré.',
    loadError: "Le bon de commande n'a pas pu être chargé.",
    newTitle: 'Nouveau bon de commande',
    editorHint: 'Articles, conditions et adresse de livraison du bon de commande.',
    pdf: 'Télécharger le PDF',
    send: 'Envoyer par email',
    confirm: 'Confirmation de commande reçue',
    confirmed: 'Bon de commande marqué comme confirmé.',
    cancel: 'Annuler la commande',
    cancelled: 'Le bon de commande a été annulé.',
    cancelTitle: 'Annuler le bon de commande {{number}} ?',
    cancelDescription:
      'Le bon de commande sera annulé définitivement et ne pourra plus être modifié par la suite.',
    cancelReason: "Motif de l'annulation",
    receiveGoods: 'Enregistrer la réception des marchandises',
    itemsTitle: 'Postes',
    itemsHint: 'Articles fournisseur avec prix échelonnés ou postes de texte libre.',
    articlePlaceholder: 'Rechercher un article',
    noSupplierProducts: "Aucun article n'est attribué à ce fournisseur.",
    freeTextPlaceholder: "Description de l'article",
    removeItem: 'Supprimer le poste',
    addItem: 'Ajouter un poste',
    net: 'Net',
    tax: 'TVA',
    gross: 'Brut',
    headerTitle: 'En-tête de commande',
    headerHint: 'Fournisseur, dates et modalités.',
    supplier: 'Fournisseur',
    supplierPlaceholder: 'Rechercher un fournisseur',
    noSuppliers: 'Aucun fournisseur trouvé.',
    minimumOrderValue: 'Valeur minimale de commande',
    deliveryTime: 'Délai',
    days: '{{count}} jours',
    expectedDelivery: 'Date de livraison prévue',
    paymentTerms: 'Conditions de paiement (jours)',
    incoterms: 'Incoterms',
    storageArea: 'Zone de stockage cible',
    storageAreaHint: 'Préremplie lors de l’enregistrement de la réception des marchandises.',
    notes: 'Remarques',
    email: {
      title: 'Envoyer le bon de commande',
      description: 'La commande est jointe au format PDF et le statut est défini sur « Envoyé ».',
      to: 'Destinataire',
      subject: 'Sujet',
      body: 'Messages',
      submit: 'Envoyer',
      sent: 'Le bon de commande a été envoyé.',
      defaultSubject: 'Bon de commande {{number}}',
      defaultBody:
        'Bonjour,\n\nVeuillez trouver ci-joint notre bon de commande {{number}}.\n\nCordialement',
    },
  },
  receipts: {
    warehouseRequired:
      'Sélectionnez le dépôt de cet emplacement. Un libellé seul ne localise pas le stock.',
    title: 'Réceptions de marchandises',
    subtitle: 'Aperçu des entrées de marchandises enregistrées et ouvertes.',
    cardTitle: 'Aperçu des entrées de marchandises',
    cardDescription: 'Toutes les livraisons enregistrées avec leur référence de bon de commande.',
    create: 'Enregistrer la réception des marchandises',
    searchPlaceholder: 'Numéro de reçu, de commande ou de bon de livraison',
    error: "Les entrées de marchandises n'ont pas pu être chargées.",
    listEmptyTitle: "Aucune entrée de marchandises pour l'instant",
    listEmptyHint: 'Enregistrez une livraison pour mettre à jour votre stock.',
    columns: {
      number: 'Numéro de reçu',
      supplier: 'Fournisseur',
      order: 'Bon de commande',
      deliveryNote: 'Bon de livraison',
      date: 'Reçu le',
      status: 'Statut',
    },
    terminalTitle: 'Enregistrer la réception des marchandises',
    terminalSubtitle:
      'Scannez la commande, vérifiez les quantités et publiez le stock de manière ferme.',
    selectOrder: 'Sélectionner le bon de commande',
    selectOrderHint:
      "Scannez le numéro de commande ou choisissez l'un des bons de commande en cours.",
    scanOrder: 'Numéro de commande de numérisation',
    scanPlaceholder: 'par ex. EK-2026-0001',
    openOrders: 'Bons de commande ouverts',
    openOrdersPlaceholder: 'Sélectionner la commande',
    emptyTitle: 'Aucun bon de commande sélectionné',
    emptyHint: 'Scannez le code-barres du bon de livraison ou sélectionnez un bon de commande.',
    loadError: "Les articles de la commande n'ont pas pu être chargés.",
    positionsTitle: 'Éléments de {{number}}',
    nothingOpen: 'Ce bon de commande ne comporte aucune quantité en cours.',
    batchManaged: 'Gestion par lots',
    open: 'Ouvert : {{quantity}} {{unit}}',
    quantityReceived: 'Quantité reçue',
    quantityInvalid: 'Veuillez saisir une quantité supérieure à 0.',
    batchNumber: 'Numéro de lot',
    batchRequired: 'Un numéro de lot est obligatoire pour les articles gérés par lots.',
    expiryDate: 'Date de péremption',
    expiryRequired: 'Veuillez saisir une date de péremption.',
    storageLocation: 'Bac de rangement / étagère',
    storageLocationPlaceholder: 'par ex. A-03-12',
    quality: 'Qualité',
    deliveryNoteTitle: 'Bon de livraison',
    deliveryNoteHint: 'Enregistrez le numéro du bon de livraison et joignez un scan ou une photo.',
    deliveryNoteNumber: 'Numéro du bon de livraison',
    storageArea: 'Zone de stockage',
    notes: 'Remarques',
    attachScan: 'Scanner ou télécharger le bon de livraison',
    noScan: 'Aucun document joint',
    blocked: 'Les éléments {{count}} sont toujours incomplets.',
    ready: 'Les éléments {{count}} seront publiés.',
    submit: "Enregistrer l'entrée de marchandises et mettre à jour le stock",
    posted: "L'entrée de marchandises {{number}} a été enregistrée et le stock a été mis à jour.",
  },
  invoices: {
    title: 'Factures fournisseur',
    subtitle: "Surveillez les créanciers par date d'échéance et date limite d'escompte.",
    cardTitle: 'Factures entrantes',
    cardDescription: 'Toutes les factures des fournisseurs avec statut de révision et de paiement.',
    create: 'Enregistrer la facture',
    createTitle: 'Enregistrer la facture du fournisseur',
    createDescription: "Enregistrez la facture d'un bon de commande et joignez le document.",
    created: 'La facture {{number}} a été enregistrée.',
    searchPlaceholder: 'Rechercher un numéro de facture ou un fournisseur',
    error: "Les factures du fournisseur n'ont pas pu être chargées.",
    emptyTitle: 'Aucune facture fournisseur trouvée',
    emptyHint: 'Enregistrez une facture fournisseur pour démarrer la révision.',
    blocked: 'Paiement bloqué',
    order: 'Bon de commande',
    orderPlaceholder: 'Sélectionner la commande',
    number: 'Numéro de facture',
    invoiceDate: 'Date de facture',
    discountPercent: "% d'escompte",
    discountDays: 'Jours de réduction',
    document: 'Document de facturation (PDF ou scanné)',
    addItem: 'Ajouter un poste',
    removeItem: 'Supprimer le poste',
    submit: 'Enregistrer la facture',
    discountHint: 'Escompte de {{percent}} % disponible pendant encore {{count}} jours',
    discountHint_one: "Escompte de {{percent}} % disponible aujourd'hui uniquement",
    discountGone: "Délai d'escompte expiré",
    kpi: {
      open: 'Montant ouvert',
      overdue: 'En retard',
      discrepancy: 'Avec écart',
      discount: 'Remise expirant',
    },
    columns: {
      number: 'Numéro de facture',
      supplier: 'Fournisseur',
      invoiceDate: 'Date de facture',
      dueDate: 'À payer le',
      discount: 'Escompte',
      status: 'Statut',
      gross: 'Brut',
      description: 'Description',
      quantity: 'Quantité',
      unitPrice: 'Prix unitaire',
      taxRate: '% TVA',
    },
  },
  match: {
    title: 'Match à trois {{number}}',
    loadError: "La correspondance de facture n'a pas pu être chargée.",
    run: 'Recalculer la correspondance',
    clear: 'Tous les éléments correspondent.',
    discrepancies: 'Les éléments {{count}} diffèrent.',
    documentTitle: 'Facture fournisseur',
    documentError: "Le document n'a pas pu être chargé.",
    noDocument: 'Aucun document joint',
    noDocumentHint: 'Téléchargez la facture au format PDF ou numérisez-la pour la consulter ici.',
    upload: 'Télécharger le document',
    uploaded: 'Le document a été stocké.',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    rotate: 'Rotation',
    reload: 'Recharger',
    tableTitle: 'Commande / livraison / facture',
    counts:
      '{{matched}} exact · {{tolerance}} dans les limites de tolérance · {{discrepancy}} divergent',
    columns: {
      position: 'Objet',
      description: 'Description',
      ordered: 'Commandé',
      delivered: 'Livré',
      invoiced: 'Facturé',
      variance: 'Écart',
      status: 'Statut',
    },
    totalVariance: 'Écart total',
    approve: 'Approuver le paiement',
    approved: 'La facture a été approuvée pour le paiement.',
    acceptTolerance: 'Accepter la tolérance manuellement',
    override: {
      title: "Accepter l'écart manuellement",
      description:
        "La raison est stockée dans le journal de correspondance et dans la piste d'audit.",
      reason: 'Raison',
      submit: 'Accepter la dérogation',
      saved: "L'écart a été accepté.",
    },
    complaint: {
      action: 'Envoyer une réclamation',
      title: 'Réclamation auprès du fournisseur',
      description: 'Le message est envoyé par email et journalisé.',
      to: 'Adresse e-mail',
      subject: 'Sujet',
      body: 'Messages',
      submit: 'Envoyer une réclamation',
      sent: 'La plainte a été envoyée.',
      defaultSubject: 'Requête concernant la facture {{number}}',
      defaultBody:
        'Bonjour,\n\nEn examinant votre facture {{number}}, nous avons constaté un écart de {{variance}} par rapport au bon de commande et à la réception de marchandises.\n\nVeuillez examiner le cas et nous envoyer une facture corrigée.\n\nCordialement',
    },
  },
} as const;
